/* The Night of Us - pre-launch page. Reveal-on-scroll, nothing else. */
(function () {
  if (window.__nouPrelaunch) return;
  window.__nouPrelaunch = true;

  var doc = document;
  doc.documentElement.classList.add('nou-js');

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function showAll(nodes) {
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-in');
  }

  function init() {
    var nodes = doc.querySelectorAll('.nou-reveal:not(.is-in)');
    if (!nodes.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      showAll(nodes);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-in');
            observer.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);

    /* Safety net: never leave content hidden if something goes wrong. */
    window.setTimeout(function () {
      showAll(doc.querySelectorAll('.nou-reveal:not(.is-in)'));
    }, 4000);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when a section is re-rendered in the theme editor. */
  doc.addEventListener('shopify:section:load', init);
  doc.addEventListener('shopify:section:select', init);
})();
